import React, { useState, useEffect, useMemo, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import TablaProyectos from './TablaProyectos';
import FiltrosTramitacionProyectos from './FiltrosTramitacionProyectos';
import Paginacion from './Paginacion';
import { optionsPartido } from '../datos/options';

import { useLocalStorage } from "../hooks/useLocalStorage";
import {useEstadoApp} from "../context/EstadoAppContext";
import { AuthContext } from '../context/authContext';


// 1. Determina los pagos válidos, el total pagado (sin adenda) y el último pago.
const getPagosData = (item) => {
    // Manejo de nulidad para area_responsable
    const area = item.area_responsable || '';

    const pagosArray = area.includes('ÁREA DE PROYECTOS')
        ? item.pago_proyectos_jsonb
        : area.includes('ÁREA DE MEJORAS')
            ? item.pago_mejoras_jsonb
            : item.pago_microcreditos_jsonb || []; // Incluye Microcréditos si es otra área

    // Pagos Válidos (monto > 0 y fecha_pago)
    const pagosValidos = (pagosArray || []).filter(p => parseFloat(p.monto) > 0 && p.fecha_pago);
    console.log("OSO pagosValidos", pagosValidos);

    // Pagos de la Obra Principal (excluye Adenda)
    const pagosObraPrincipal = pagosValidos.filter(p => p.tipo_pago !== 'adenda');
    console.log("OSO pagosObraPrincipal", pagosObraPrincipal);

    // Monto Total Pagado (SOLO obra principal)
    const montoTotalPagadoObra = pagosObraPrincipal.reduce((sum, p) => sum + parseFloat(p.monto), 0);

    // El último pago considera *todos* los pagos (incluida la adenda)
    /*const ultimoPago = pagosValidos.length > 0
        ? pagosValidos.sort((a, b) => new Date(b.fecha_pago) - new Date(a.fecha_pago))[0]
        : null;*/
    // ⭐️ CORRECCIÓN AQUÍ: El último pago solo considera la obra principal
    const ultimoPago = pagosObraPrincipal.length > 0
        ? pagosObraPrincipal.sort((a, b) => new Date(b.fecha_pago) - new Date(a.fecha_pago))[0]
        : null;
    console.log("OSO ultimoPago", ultimoPago);

    // Obtener el último porcentaje de obra válido (el mayor valor de porcentaje_obra que no sea nulo o indefinido)
    const ultimoPorcentajeObra = pagosObraPrincipal.length > 0
        ? Math.max(...pagosObraPrincipal
            .map(p => parseFloat(p.porc_avance_obra) || 0)
            .filter(porcentaje => !isNaN(porcentaje) && porcentaje > 0)
        )
        : 0;    

    return {
        montoTotalPagado: montoTotalPagadoObra,
        ultimoPago,
        ultimoPorcentajeObra,
        pagosValidos, // Array completo de pagos válidos
        pagosObraPrincipal // Array de pagos válidos excluyendo Adenda
    };
};

// 2. Determina la etapa de pago según el porcentaje y el area responsable.
const getEtapaPago = (percentage, area) => {
    //if (area === 'ÁREA DE PROYECTOS') {
    if (percentage === 0) return 'Sin Pago';
    if (percentage > 0 && percentage <= 50) return 'Anticipo';
    if (percentage > 50 && percentage <= 99) return '2do. Pago';
    if (percentage === 100) return 'Pago Total';
    return 'Pago Excedido';
    /*} else if(area === 'AREA DE MEJORAS' || area === 'AREA DE MICROCRÉDITOS') {
        if (percentage === 0) return 'Sin Pago';		
        if (percentage > 0) return 'Pago Total';
        return 'Pago Excedido';
    }*/
};

const TablaTramitacionProyectoContainer = ({arrayEditando }) => {//handleIsEditing
    const { setItem, removeItem } = useLocalStorage();
    
    const { estadoAppX, cambiarEstadoApp } = useEstadoApp(); // Usamos nuestro custom hook
    const {user} = useContext(AuthContext)
    
    const navigate = useNavigate();

    const [data, setData] = useState([]); // Aquí iría tu fetch de la API
    const [filters, setFilters] = useState({
        partido_nombre: '',
        encargado_proyecto: '',
        encargado_rendicion: '',
        ong: '',
        avance_financiero: '',
        avance_obra: '',
        fechaInicioObra: '',
        fechaFinObra: '',
        referente_politico_nombre: '',
        searchQuery: '' // mantener para cuadro de busqueda
    });

    console.log("Avance obra", filters.avance_obra)
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDatos = async () => {
            setIsLoading(true);
            try {
                const response = await fetch('/api/tabla_tramitacion_proyectos');
                if (!response.ok) {
                    throw new Error('Error al obtener los datos de la API');
                }
                const data = await response.json();
                setData(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchDatos();
    }, []);

    	const handleFilterChange = (filterName, value) => {
		setFilters(prevFilters => ({
			...prevFilters,
			[filterName]: value,
		}));
		// Resetear página a 1 cuando cambian filtros
		setCurrentPage(1);
	};

	const limpiarFiltros = () => {
        setFilters({
            partido_nombre: '',
            encargado_proyecto: '',
            encargado_rendicion: '',
            ong: '',
            avance_financiero: '',
            avance_obra: '',
            fechaInicioObra: '',
            fechaFinObra: '',
            referente_politico_nombre: '',
            searchQuery: ''
        });
    };

    // 🌟 Pre-procesamiento y aplanamiento de datos.
    const processedData = useMemo(() => {
        let result = [];
        data.forEach(item => {
            const { montoTotalPagado, ultimoPago, ultimoPorcentajeObra, pagosValidos } = getPagosData(item);
            
            const area = item.area_responsable || '';

            const array_expedientes_jsonb = item.array_expedientes_jsonb || []; //nuevo 12-marz-2026
            const observ_seguimiento_obra = item.observ_seguimiento_obra || "";
            //const nroExpProyecto = item.tramitacion_externa_jsonb?.find(t => t?.objeto === 'Proyecto')?.exp || 'N/A';

            //obtenemos el exp de Proyecto y el exp de Rendicion desde el array de expedientes (y no desde tramitacion_externa_jsonb)
            //PROBLEMA: si tramitacion_externa_jsonb no se cargaba los datos de Proyecto y Rendicion no se tenian en cuenta porque los trae desde la tabla de expedientes 
            const nroExpProyecto = array_expedientes_jsonb.find(t => t?.objeto_o === 'Proyecto')?.expediente_o || 'N/A';
            const nroExpRendicion = array_expedientes_jsonb.find(t => t?.objeto_o === 'Rendición')?.expediente_o || 'N/A';


            let organismo_solicitante = item.organismo_otro;
            if (item.tipo_subsidio === "Subsidio a municipio") {
                organismo_solicitante = "Municipio de " + item.partido_nombre;
            } else if (item.tipo_subsidio === "Subsidio a ONG") {
                organismo_solicitante = "ONG " + item.organismo_solicitante;
            }

            //solo Proyecto(cambiamos Rendición por Proyecto), sin Adendas+. El problema: si no tiene expediente de Rendición lo filtra y no se muestra
            //si ponemos Proyecto y Rencion se generan registros duplicados
            const tramitacionesFiltradas = item.tramitacion_externa_jsonb?.filter(t => t?.objeto === 'Proyecto'  || t?.objeto === '') || []; //|| t?.objeto === 'Rendición' || t.objeto === 'Adenda'
            //todo lo que sea distinto a objeto Adenda
            //const tramitacionesFiltradas = item.tramitacion_externa_jsonb.filter(t => t.objeto === 'Proyecto');

            tramitacionesFiltradas.forEach(tramite => {
                const objeto = tramite.objeto;
                let montoConvenioAdenda = '';
                let montoPagadoFila = montoTotalPagado;
                let avancePagos = 0;
                let etapaActual = '';

                if (objeto === 'Rendición') {
                    montoConvenioAdenda = `$${parseFloat(item.monto_obra).toLocaleString('es-AR')}`;

                    if (parseFloat(item.monto_obra) > 0) {
                        avancePagos = (montoPagadoFila / parseFloat(item.monto_obra)) * 100;
                        if (avancePagos > 100) avancePagos = 100;
                    }
                    etapaActual = getEtapaPago(avancePagos, area);//agregar el area tambien
                    console.log("ETAPA ACTUAL", etapaActual)

                }

                result.push({
                    ...item,
                    objeto,
                    montoConvenioAdenda,
                    montoPagadoFila,
                    avancePagos,
                    etapaActual,
                    nroExpProyecto,
                    nroExpediente: nroExpRendicion, //tramite.exp,
                    organismo_solicitante,
                    observ_seguimiento_obra,
                    ultimoPago: ultimoPago,
                    pagosValidos: pagosValidos,
                    ultimoPorcentajeObra: ultimoPorcentajeObra,
                    id_partido_obra: item.cg_01_id_partido_obra
                });
            });
        });
        return result;
    }, [data]);
    console.log("DOS PROCESSED DATA", processedData);
    // Debug: Verificar estructura de processedData
    if (processedData.length > 0) {
        console.log("DEBUG - Primer item de processedData:", processedData[0]);
        console.log("DEBUG - ultimoPago del primer item:", processedData[0].ultimoPago);
        console.log("DEBUG - tipo_pago del ultimoPago:", processedData[0].ultimoPago?.tipo_pago);
    }

    // 🔄 Lógica de Filtrado
    const filteredData = useMemo(() => {
        let currentData = processedData;
        console.log("que tiene CURRENT DATA", currentData)
        const { fechaInicioObra, fechaFinObra, searchQuery, ong, encargado_rendicion } = filters;

        // Filtro por partido
        if (filters.partido_nombre) {
            const partidoSeleccionado = optionsPartido.find(p => p.value === filters.partido_nombre);
            currentData = currentData.filter(item => item.partido_nombre === partidoSeleccionado?.label);
        }

        // Filtro por ONG/Cooperativa
        if (ong) {
            currentData = currentData.filter(item => 
                item.organismo_solicitante && 
                item.organismo_solicitante.toLowerCase().includes(ong.toLowerCase())
            );
        }

        // Filtro por encargado de rendición.
        if (encargado_rendicion) {
            currentData = currentData.filter(item => 
                item.encargado_rendicion === encargado_rendicion
            );
        }

        // 1. Filtro por Objeto ----> cambiar por Organismo solicitante
        if (filters.organismo_solicitante) {
            currentData = currentData.filter(item => item.tipo_subsidio === filters.organismo_solicitante);                       
        }

        //filtro por Encargado de Proyecto
        if(filters.encargado_proyecto){
            currentData = currentData.filter(item => item.encargado_proyecto === filters.encargado_proyecto)
        }

        // 2. Filtro por Documentación
        if (filters.documentacion) { //!== 'Todos'
            currentData = currentData.filter(item => {
                const { resolucion, documentacion_pago_ok } = item.tramitacionInterna;
                switch (filters.documentacion) {
                    case 'Resolución':
                        return resolucion === true;
                    case 'Documentación para el pago':
                        return documentacion_pago_ok === true;
                    case 'Ambas':
                        return resolucion === true && documentacion_pago_ok === true;
                    default:
                        return true;
                }
            });
        }

        // 3. Filtro por Etapa de pago (solo Rendición)
        if (filters.avance_financiero) {//!== 'Todos'
            currentData = currentData.filter(item => {
                // Debug: Verificar valores antes del filtro
                //console.log('DEBUG FILTRO AVANCE_FINANCIERO - Item:', item.id, 'objeto:', item.objeto, 'ultimoPago:', item.ultimoPago);

                if (item.objeto !== 'Proyecto' && item.objeto !== 'Rendición') return false;                

                switch (filters.avance_financiero) {
                    case 'anticipo':
                        const isAnticipo = item.ultimoPago && item.ultimoPago.tipo_pago === 'anticipo';
                        //console.log('DEBUG - anticipo:', isAnticipo, 'tipo_pago:', item.ultimoPago?.tipo_pago);
                        return isAnticipo;
                    case '2do_pago':
                        const is2doPago = item.ultimoPago && item.ultimoPago.tipo_pago === '2do_pago';
                        //console.log('DEBUG - 2do_pago:', is2doPago, 'tipo_pago:', item.ultimoPago?.tipo_pago);
                        return is2doPago;
                    case '3er_pago':
                        const is3erPago = item.ultimoPago && item.ultimoPago.tipo_pago === '3er_pago';
                        //console.log('DEBUG - 3er_pago:', is3erPago, 'tipo_pago:', item.ultimoPago?.tipo_pago);
                        return is3erPago;
                    case 'total':
                        const isTotal = item.ultimoPago && item.ultimoPago.tipo_pago === 'total';
                        //console.log('DEBUG - total:', isTotal, 'tipo_pago:', item.ultimoPago?.tipo_pago);
                        return isTotal;
                    default:
                        return false;
                }
            });
        }

        //filtrar por avance obra
        if (filters.avance_obra) {
            
            /*console.log("Filtering for avance_obra:", filters.avance_obra, "(type:", typeof filters.avance_obra, ")");
            console.log("Sample ultimoPorcentajeObra values:", currentData.slice(0, 5).map(item => ({
                id: item.id,
                ultimoPorcentajeObra: item.ultimoPorcentajeObra,
                type: typeof item.ultimoPorcentajeObra
            })));*/
            
            currentData = currentData.filter(item => {
                const avanceObra = Number(filters.avance_obra);
                const match = item.ultimoPorcentajeObra === avanceObra;
                //console.log(`Item ${item.id} - ultimoPorcentajeObra: ${item.ultimoPorcentajeObra} (${typeof item.ultimoPorcentajeObra}) - Match: ${match}`);
                return match;
            });
            
            //console.log("Filtered data count:", currentData.length);
        }

        //Filtro por referente político
        /*if (filters.referente_politico_nombre !== undefined) {
            if (filters.referente_politico_nombre === '') {
                // Mostrar registros donde referente_politico_nombre es null, undefined o string vacío
                currentData = currentData.filter(item => 
                    !item.referente_politico_nombre || 
                    item.referente_politico_nombre.trim() === ''
                );
            } else {
                // Mostrar registros que coincidan exactamente con el referente seleccionado
                currentData = currentData.filter(item => 
                    item.referente_politico_nombre === filters.referente_politico_nombre
                );
            }
        }*/
       if (filters.referente_politico_nombre) {
            currentData = currentData.filter(item => 
                item.referente_politico_nombre === filters.referente_politico_nombre
            );
        }

        // 4. Filtro por Rango de Fechas de Obra (Inicio y Fin)
        if (fechaInicioObra || fechaFinObra) {
            console.log('=== FILTRO FECHAS ACTIVADO ===');
            console.log('Filtro - Fecha Inicio:', fechaInicioObra, '| Fecha Fin:', fechaFinObra);
            
            currentData = currentData.filter(item => {
                console.log('\n--- Procesando item ---');
                console.log('ID Obra:', item.id, '| Nombre:', item.nombreObra);
                console.log('Fechas en el item - Inicio:', item.fecha_inicio_obra, '| Fin:', item.fecha_fin_obra);
                
                const fechaInicioObraItem = item.fecha_inicio_obra ? new Date(item.fecha_inicio_obra) : null;
                const fechaFinObraItem = item.fecha_fin_obra ? new Date(item.fecha_fin_obra) : null;
                
                console.log('Fechas parseadas - Inicio:', fechaInicioObraItem, '| Fin:', fechaFinObraItem);

                // Si no hay fechas de obra, no se incluye en el filtro
                if (!fechaInicioObraItem && !fechaFinObraItem) {
                    console.log('❌ No hay fechas de obra para este item');
                    return false;
                }

                let cumpleInicio = true;
                let cumpleFin = true;

                // Compara con Fecha de Inicio
                if (fechaInicioObra) {
                    const start = new Date(fechaInicioObra);
                    start.setHours(0, 0, 0, 0);
                    console.log('Filtro Inicio (start of day):', start);
                    // Si hay fecha de inicio de obra, debe ser mayor o igual a la fecha de inicio del filtro
                    if (fechaInicioObraItem) {
                        cumpleInicio = fechaInicioObraItem >= start;
                        console.log(`Comparando inicio: ${fechaInicioObraItem} >= ${start} -> ${cumpleInicio}`);
                    } else {
                        // Si no hay fecha de inicio de obra, pero sí fecha de fin, usamos esa para la comparación
                        if (fechaFinObraItem) {
                            cumpleInicio = fechaFinObraItem >= start;
                            console.log(`Usando fecha fin para comparar inicio: ${fechaFinObraItem} >= ${start} -> ${cumpleInicio}`);
                        } else {
                            console.log('❌ No hay fechas válidas para comparar con inicio');
                            return false; // No hay fechas de obra para comparar
                        }
                    }
                }

                // Compara con Fecha de Fin
                if (fechaFinObra) {
                    const end = new Date(fechaFinObra);
                    end.setHours(23, 59, 59, 999);
                    console.log('Filtro Fin (end of day):', end);
                    // Si hay fecha de fin de obra, debe ser menor o igual a la fecha de fin del filtro
                    if (fechaFinObraItem) {
                        cumpleFin = fechaFinObraItem <= end;
                        console.log(`Comparando fin: ${fechaFinObraItem} <= ${end} -> ${cumpleFin}`);
                    } else {
                        // Si no hay fecha de fin de obra, pero sí fecha de inicio, usamos esa para la comparación
                        if (fechaInicioObraItem) {
                            cumpleFin = fechaInicioObraItem <= end;
                            console.log(`Usando fecha inicio para comparar fin: ${fechaInicioObraItem} <= ${end} -> ${cumpleFin}`);
                        } else {
                            console.log('❌ No hay fechas válidas para comparar con fin');
                            return false; // No hay fechas de obra para comparar
                        }
                    }
                }

                console.log(`Resultado para ${item.nombreObra}: cumpleInicio=${cumpleInicio}, cumpleFin=${cumpleFin} -> ${cumpleInicio && cumpleFin ? '✅ INCLUIDO' : '❌ EXCLUIDO'}`);
                return cumpleInicio && cumpleFin;
            });
        }

        // ⭐️ 5. Filtro por Búsqueda de Texto (Search Query) ⭐️
        if (searchQuery) {
            const query = searchQuery.toLowerCase().trim();

            currentData = currentData.filter(item => {
                // Campos a buscar: Nombre de obra, Nro. Exp. Proyecto, nombre de Partido.
                const nombreObra = item.nombre_obra?.toLowerCase() || '';
                const nroExpProyecto = item.nroExpProyecto?.toLowerCase() || '';
                // Necesitamos acceder al nombre del partido original. 
                // Para esto, debemos asegurarnos de agregarlo en processedData.

                // Si no lo tienes aún en processedData, asegúrate de agregarlo en el paso A:
                // "partidoNombre: item.partido_nombre,"
                const partidoNombre = item.partido_nombre?.toLowerCase() || '';

                return (
                    nombreObra.includes(query) ||
                    nroExpProyecto.includes(query) ||
                    partidoNombre.includes(query)
                );
            });
        }

        return currentData;
    }, [processedData, filters]);

    // ⬇️ Lógica de Paginación ⬇️
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
        <div className="w-full p-4">
            <h2 className="text-2xl font-bold mb-4">Tramitación Proyectos</h2>
            <FiltrosTramitacionProyectos 
                filters={filters}
                data={processedData} //probar pasar los datos aplanados para crear select de ongs con valores unicos 
                onFilterChange={handleFilterChange}
                limpiarFiltros={limpiarFiltros}
            />

            <TablaProyectos 
                data={currentItems} 
                arrayEditando={arrayEditando}
            />

            <Paginacion
                currentPage={currentPage}
                totalPages={totalPages}
                setCurrentPage={setCurrentPage}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                totalItems={filteredData.length}
            />
        </div>
    );
};

export default TablaTramitacionProyectoContainer;